<script lang="ts">
	import { isVideo } from '#lib/helper/media.js';

	interface Props {
		src: string | null | undefined;
		alt?: string;
		className?: string;
	}

	let { src, alt = '', className = 'w-full h-full object-cover' }: Props = $props();
</script>

{#if src}
	{#if isVideo(src)}
		<video {src} class={className} autoplay loop muted playsinline></video>
	{:else}
		<img {src} {alt} class={className} />
	{/if}
{/if}
